import { storagePath } from "apiRoutes/storagePath";
import { Looop } from "shared/games/Looop";
import Instrument from "./instruments/Instrument";

const cacheName = "audio-file-cache-v2";

export async function preloadLooop(
  looop: Looop,
  instrumentsToInclude?: Instrument[]
) {
  const { instruments, base_audio_url } = looop;
  const promises: Promise<any>[] = Object.values(instruments).flatMap(
    (instrument) => {
      // return noop promise if we're only preloading certain instruments
      // otherwise load them all
      if (
        instrumentsToInclude &&
        instrumentsToInclude.length > 0 &&
        !instrumentsToInclude.includes(instrument.instrument)
      ) {
        return new Promise((res) => res(null));
      }

      return Object.values(instrument.audio_files).flatMap((audioFile) =>
        fetchAudioFileByUrl(storagePath(base_audio_url + audioFile))
      );
    }
  );

  return await Promise.all(promises);
}

export default function fetchAudioFileByUrl(url: string): Promise<ArrayBuffer> {
  return new Promise(async (res, rej) => {
    const cache = "caches" in window ? await caches.open(cacheName) : null;
    const cacheResponse = await cache?.match(url);

    if (cacheResponse) {
      return res(cacheResponse.arrayBuffer());
    }

    const request = new XMLHttpRequest();

    request.open("GET", url, true);
    request.responseType = "arraybuffer";

    request.onload = () => {
      cache?.put(url, new Response(request.response));
      res(request.response);
    };

    request.onerror = () => {
      rej();
    };

    request.send();
  });
}
